module.exports = {"en":{"news":"Latest news"},"de":{"news":"Neueste Meldungen"},"fr":{"news":"Actualités"},"ru":{"news":"Свежие новости"},"ja":{"news":"最新ニュース"},"zh":{"news":"最新资讯"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/MainSection/main-section.json
// module id = 1112
// module chunks = 0